<div class="filter-setting-list">
    <div class="catalog-button">
        <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'json'"
                [label]="'catalog.button.update' | translate"
                (clickEmitter)="openEditCatalogJsonDialog($event)"
        ></app-button>
    </div>
    <div class="catalog-button">
        <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'edit'"
                [label]="'catalog.button.updateForm' | translate"
                (clickEmitter)="openEditCatalogFormDialog($event)"
        ></app-button>
    </div>
    <div class="catalog-button">
        <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'plus'"
                [label]="'catalog.button.addFilterSetting' | translate"
                (clickEmitter)="openAddFilterSettingDialog($event)"
        ></app-button>
    </div>
    <table mat-table [dataSource]="filterSettingsAsArray" class="mat-elevation-z0" matSort (matSortChange)="sortChange($event)">

        <ng-container matColumnDef="moduleCategoryReference">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"filterSettingList.column.moduleCategoryReference" | translate}}</th>
            <td mat-cell *matCellDef="let filterSetting"> {{filterSetting.moduleCategoryReference}} </td>
        </ng-container>

        <ng-container matColumnDef="attributeId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"filterSettingList.column.attributeId" | translate}}</th>
            <td mat-cell *matCellDef="let filterSetting"> {{filterSetting.attributeId}} </td>
        </ng-container>

        <ng-container matColumnDef="attributeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"filterSettingList.column.attributeName" | translate}}</th>
            <td mat-cell *matCellDef="let filterSetting"> {{filterSetting.attributeName}} </td>
        </ng-container>

        <ng-container matColumnDef="attributeType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"filterSettingList.column.attributeType" | translate}}</th>
            <td mat-cell *matCellDef="let filterSetting"> {{filterSetting.attributeType}} </td>
        </ng-container>

        <ng-container matColumnDef="attributeValue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"filterSettingList.column.attributeValue" | translate}}</th>
            <td mat-cell *matCellDef="let filterSetting"> {{filterSetting.attributeValue}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{"filterSettingList.column.action" | translate}}</th>
            <td mat-cell *matCellDef="let filterSetting">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'filterSettingList.tooltip.upload' | translate"
                            (click)="fileInput.click()">
                        <mat-icon class="icon">upload_file</mat-icon>
                        <input #fileInput type="file" class="file-upload" hidden
                               (change)="assetUpload(filterSetting, $event)">
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
</div>

